import gql from 'graphql-tag';

export const GET_MERCHANT_CAMPAIGNS_RESULTS = gql`
  query CampaignFindBy($params: CampaignFindByInput!) {
    campaignFindBy(params: $params) {
      campaign {
        uuid
        name
        startDate
        endDate
      }
      advertiser {
        name
        type
        merchantUuid
      }
      budgets {
        totalBudget
        uuid
        balance
        type
        createdAt
        advertiser {
          name
          type
          merchantUuid
        }
        adjustments {
          adjustmentId
          adjustmentName
          adjustmentAmount
          adjustmentCurrency
          adjustmentApprovalDate
          adjustmentCreatedAt
          insertionOrder {
            uuid
            ticket
          }
        }
      }
      insertionOrder {
        uuid
        ticket
      }
    }
  }
`;

export default GET_MERCHANT_CAMPAIGNS_RESULTS;
